import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "ellipsis-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { id: "16x16/Filled/Ellipsis", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M8 6a2 2 0 110 4 2 2 0 010-4zM2 6a2 2 0 110 4 2 2 0 010-4zm12 0a2 2 0 110 4 2 2 0 010-4z", id: "Combined-Shape", fill: "currentColor", fillRule: "nonzero" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
